import React, { useState, useEffect } from "react";
import logoNiralakka from "../img/image (3).png";
import logoNiralakkaMini from "../img/image (4).png";
import { useAuth } from "../context/AuthContext";
import { NavLink, Link } from "react-router-dom";
import { FaChevronLeft, FaChevronRight, FaTicketAlt, FaQuestionCircle, FaTimesCircle, FaPlus } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import './Sidebar.styles.css';

export default function Sidebar({ onFilterChange, filtre, isOnTicketPage, isCollapsed, setIsCollapsed, onCreateTicket }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { logOut } = useAuth();

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const MobileMenu = () => (
    <>
      <button
        className="burger-menu-btn"
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        aria-label={mobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={mobileMenuOpen}
      >
        {mobileMenuOpen ? <IoMdClose size={24} /> : <GiHamburgerMenu size={24} />}
      </button>

      <div
        className={`mobile-menu-overlay${mobileMenuOpen ? " active" : ""}`}
        onClick={() => setMobileMenuOpen(false)}
        aria-hidden="true"
      />

      <div className={`mobile-menu-drawer${mobileMenuOpen ? " open" : ""}`}>
        <div className="d-flex align-items-center justify-content-center mb-4">
          <Link to="/tickets" onClick={() => setMobileMenuOpen(false)}>
            <img src={logoNiralakka} alt="Niralakka" style={{ width: "80%", maxWidth: "180px" }} />
          </Link>
        </div>

        <hr className="sidebar-divider" />

        {isOnTicketPage && (
          <ul className="navbar-nav" style={{ listStyle: "none", padding: 0 }}>
            {onCreateTicket && (
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={() => { onCreateTicket(); setMobileMenuOpen(false); }}
                  style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}
                >
                  <FaPlus className="me-2" />
                  <span>Nouveau ticket</span>
                </button>
              </li>
            )}
            <li className="nav-item">
              <button
                className={`nav-link${filtre === "ouvert" ? " active" : ""}`}
                onClick={() => { onFilterChange("ouvert"); setMobileMenuOpen(false); }}
                style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}
              >
                <FaTicketAlt className="me-2" />
                <span>Tickets ouverts</span>
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link${filtre === "ferme" ? " active" : ""}`}
                onClick={() => { onFilterChange("ferme"); setMobileMenuOpen(false); }}
                style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}
              >
                <FaTimesCircle className="me-2" />
                <span>Tickets fermés</span>
              </button>
            </li>
          </ul>
        )}

        <hr className="sidebar-divider" />

        <ul className="navbar-nav" style={{ listStyle: "none", padding: 0 }}>
          <li className="nav-item">
            <NavLink
              to="/aide"
              className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              <FaQuestionCircle className="me-2" />
              <span>Aide</span>
            </NavLink>
          </li>
          {onCreateTicket && (
            <li className="nav-item">
              <button
                className="nav-link"
                onClick={() => { onCreateTicket(); setMobileMenuOpen(false); }}
                style={{ background: "none", border: "none", width: "100%", textAlign: "left" }}
              >
                <FaPlus className="me-2" />
                <span>Nouveau ticket</span>
              </button>
            </li>
          )}
        </ul>
      </div>
    </>
  );

  const DesktopSidebar = () => (
    <>
      <ul
        className={`navbar-nav bg-gradient-primary sidebar sidebar-dark accordion${isCollapsed ? " toggled" : ""}`}
        id="accordionSidebar"
      >
        <Link to="/tickets" className="sidebar-brand">
          <img
            src={isCollapsed ? logoNiralakkaMini : logoNiralakka}
            alt="Niralakka"
            className={`sidebar-logo${isCollapsed ? " sidebar-logo--collapsed" : " sidebar-logo--expanded"}`}
          />
        </Link>

        <hr className="sidebar-divider" />

        {isOnTicketPage && (
          <>
            {!isCollapsed && (
              <div className="sidebar-heading">Tickets</div>
            )}
            {onCreateTicket && (
              <li className="nav-item">
                <button
                  className="nav-link"
                  onClick={onCreateTicket}
                  title={isCollapsed ? "Nouveau ticket" : undefined}
                >
                  <FaPlus />
                  {!isCollapsed && <span className="ms-2">Nouveau ticket</span>}
                </button>
              </li>
            )}
            <li className="nav-item">
              <button
                className={`nav-link${filtre === "ouvert" ? " active" : ""}`}
                onClick={() => onFilterChange("ouvert")}
                title={isCollapsed ? "Tickets ouverts" : undefined}
              >
                <FaTicketAlt />
                {!isCollapsed && <span className="ms-2">Tickets ouverts</span>}
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link${filtre === "ferme" ? " active" : ""}`}
                onClick={() => onFilterChange("ferme")}
                title={isCollapsed ? "Tickets fermés" : undefined}
              >
                <FaTimesCircle />
                {!isCollapsed && <span className="ms-2">Tickets fermés</span>}
              </button>
            </li>
            <hr className="sidebar-divider" />
          </>
        )}

        <li className="nav-item">
          <NavLink
            to="/aide"
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            title={isCollapsed ? "Aide" : undefined}
          >
            <FaQuestionCircle />
            {!isCollapsed && <span className="ms-2">Aide</span>}
          </NavLink>
        </li>
      </ul>

      <button
        className="btn btn-white btn-sm rounded-circle sidebar-toggle-btn"
        style={{
          position: 'fixed',
          left: isCollapsed ? 'calc(6.5rem - 1rem)' : 'calc(14rem - 1rem)',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 200,
          transition: 'left 0.3s',
        }}
        onClick={() => setIsCollapsed(!isCollapsed)}
        aria-label={isCollapsed ? "Déplier le menu" : "Replier le menu"}
      >
        {isCollapsed ? <FaChevronRight size={12} /> : <FaChevronLeft size={12} />}
      </button>
    </>
  );

  return isMobile ? <MobileMenu /> : <DesktopSidebar />;
}
